/**
 * Writes lib/clientInheritance's fixes: every sub-project with no client gets
 * its nearest ancestor's. Run by the Todoist sync, and after a client is linked
 * here so the subs follow straight away rather than on the next sync.
 */

import { pb } from "./pocketbase";
import { inheritedClientFixes } from "./clientInheritance";
import type { Project } from "./types";

/** Returns how many projects were filled in. Failures go to `errors` if given. */
export async function applyInheritedClients(errors?: string[]): Promise<number> {
  const projects = await pb.collection("projects").getFullList<Project>();
  let filled = 0;
  for (const fix of inheritedClientFixes(projects)) {
    try {
      await pb.collection("projects").update(fix.id, { client: fix.client, clientRef: fix.clientRef });
      filled++;
    } catch (e) {
      errors?.push(`Client for "${fix.name}": ${e instanceof Error ? e.message : String(e)}`);
    }
  }
  return filled;
}
